import type { RecursivePartial } from '#types/utils'
import type { ProductUpsellConfig } from '#types/config/components/product/upsell'

export default {
  image: {
    height: 79,
    width: 68
  },
} satisfies RecursivePartial<ProductUpsellConfig>
